module.exports = __webpack_public_path__ + "img/resource-bg-magenta.5101af17.png";